<template>
  <div class="account-section">
    <section class="info-wrapper">
      <BliOnboardingTooltip
        position="right"
        :is-active="showOnboardingModal"
        with-mask
      >
        <template #onboarding-tooltip-highlight>
          <section class="dealer">
            <div :class="['dealer_container', {dealer_onboarding: showOnboardingModal}]">
              <div class="dealer_mail">
                {{ userDetails?.email || '' }}
              </div>
              <div
                :class="['dealer_detail', {'dealer_cursor': isCompanySwitchAccesible}]"
                @click="handleCompanySwitchClick"
              >
                <div class="dealer_name">
                  {{ currentCompanyInfo?.companyName || '' }}
                </div>
                <BliBadge
                  v-if="showParentBadge"
                  color="blue"
                  prominence="tertiary"
                >
                  {{ $t('appHeader.parent') }}
                </BliBadge>
                <BliIconSiChevronDown
                  v-if="isCompanySwitchAccesible"
                  class="chevron"
                  width="16"
                  height="16"
                />
              </div>
            </div>
          </section>
        </template>
        <template #onboarding-tooltip-title>
          {{ $t('onboarding.title') }}
        </template>
        <template #onboarding-tooltip-image>
          <img
            class="tooltip-gif"
            src="@vue3/assets/images/onboarding-parent-child.gif"
            alt="imagedesc"
          >
        </template>
        <template #onboarding-tooltip-desc>
          {{ $t('onboarding.description') }}
        </template>
        <template #onboarding-tooltip-action>
          <BliButton
            size="small"
            @click="setShowOnboardingModal(false)"
          >
            {{ $t('onboarding.button') }}
          </BliButton>
        </template>
      </BliOnboardingTooltip>

      <div class="icon-container">
        <div
          v-if="isNotificationPermissionGranted"
          class="icon-container-wrapper"
        >
          <BliIconSiNotification
            class="navigation-icon"
            @click.native="handleNotificationClick"
          />
          <BliBadge
            v-if="getUnreadNotificationCount"
            notification
            class="notification-badge"
          >
            {{ getUnreadNotificationCount }}
          </BliBadge>
        </div>
        <BliIconSiSetting
          class="navigation-icon"
          @click.native="handleSettingsClick"
        />
      </div>
    </section>
    <template v-if="isHomePageRoute">
      <div
        v-if="isHomePageRoute"
        class="separator"
      />
      <EngagementInfo v-if="isHomePageRoute" />
    </template>
  </div>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
  @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
  @import './index.scss';
</style>
